export const SeriesMarker = ({
  marker,
  x,
  y,
}: {
  marker: number;
  x: number;
  y: number;
}) => {
  if (marker === 1) return <path d={`M${x},${y - 4} l4,4 -4,4 -4,-4 Z`} />;
  if (marker === 2)
    return <rect x={x - 3.5} y={y - 3.5} width={7} height={7} />;
  if (marker === 3) return <path d={`M${x},${y - 4} l4,7 h-8 Z`} />;
  return <circle cx={x} cy={y} r={3.5} />;
};
